export const PAGE_STAGES_KEYS = {
  SEARCH_BANK_SLIP: 'SEARCH_BANK_SLIP',
  RESPONSE_BANK_SLIP: 'RESPONSE_BANK_SLIP',
  LIST_BANK_SLIP: 'LIST_BANK_SLIP',
}
